import { render, staticRenderFns } from "./CustomerContactsTab.html?vue&type=template&id=af15a934&scoped=true&"
import script from "./CustomerContactsTab.ts?vue&type=script&lang=ts&"
export * from "./CustomerContactsTab.ts?vue&type=script&lang=ts&"
import style0 from "./CustomerContactsTab.scss?vue&type=style&index=0&id=af15a934&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af15a934",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
